<template>
  <ul>
    <li v-for="value in filteredValues" :key="value.id">
      <button
        class="list-filter-button"
        :class="{ 'list-filter-button--active': isFilterSelected(value) }"
        @click="handleListItemClick(value)"
      >
        {{ value.label }} ({{ value.count }})
      </button>
    </li>
  </ul>
</template>

<script>
import isEqual from "lodash-es/isEqual";
export default {
  name: "ListFilter",
  props: {
    values: {
      type: Array,
      default: () => [],
    },
    filters: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["change"],
  computed: {
    filteredValues() {
      return this.values.filter((value) => value.count > 0);
    },
  },
  methods: {
    isFilterSelected(value) {
      const valueInput = JSON.parse(value.input);

      const filterKey = Object.keys(valueInput)[0];
      const selectedFilters = JSON.parse(JSON.stringify(this.filters));

      const selectedFiltersHasSelectedFilter = selectedFilters?.some(
        (selectedFilter) => {
          if (isEqual(selectedFilter[filterKey], valueInput[filterKey])) {
            return true;
          }
          return false;
        }
      );

      return selectedFiltersHasSelectedFilter;
    },
    handleListItemClick(value) {
      this.$emit("change", JSON.parse(value.input));
    },
  },
};
</script>

<style lang="scss" scoped>
.list-filter-button {
  display: block;
  width: 100%;
  background: none;
  outline: none;
  border: none;
  text-align: left;
  font-size: 10px;
  padding: 10px 0;
  text-transform: capitalize;

  &--active {
    font-weight: 600;
  }
}
</style>
